import React, { useState, useEffect } from 'react';
import './styles.css';
import {
  Row,
  Col,
  Form,
  Button,
  Input,
  Checkbox,
  notification
} from 'antd';
import { useSendMessage} from '@BUP/hooks';

const SendMessageForm = () => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { handleSendMessage } = useSendMessage();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const comment = {
        content: values?.message || "",
        anonymus: values?.anonymous
      }
      await handleSendMessage(comment);
      notification['info']({
        style: { fontWeight: 500, fontSize: 17 },
        message: '¡Mensaje Enviado!',
        description:
          'Hola, esperamos que te encuentres bien y que la situación que nos cuentas se pueda resolver positivamente. El encargado de convivencia ya cuenta con tu mensaje y en menos de 24 horas te responderá. Muchas gracias por utilizar este espacio y confiar en el modo BUP.',
        duration: 20
      });
      setError(null);
      form.resetFields();
    } catch (e) {
      console.log("send message form", e)
      setError({
        message: "Ocurrio un error inesperado, por favor vuelve a intentarlo."
      })
    }
  };

  return (
    <Col xs={24} lg={18} xxl={18} className="send-message-form-container">
      <h1>¡Tu voz es importante!</h1>
      <h2>Hazte oír, estamos aquí para escucharte</h2>
      <Row style={{ marginTop: 20 }}>
        {
          error && error?.message ? (
            <Col xs={24} className="error-wrapper">
              <span>{error?.message}</span>
            </Col>
          ) : null
        }
        <Col xs={24} className="form-wrapper">
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: "Debes ingresar un mensaje.",
                }
              ]}
            >
              <Input.TextArea
                size="large"
                placeholder="Ej: Tengo un problema con..."
                autoSize={{ minRows: 3 }}
              />
            </Form.Item>
            <Form.Item
              name="anonymous"
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox
                style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
              >
                Enviar Anónimamente
              </Checkbox>
            </Form.Item>
            <Form.Item shouldUpdate={true}>
              {() => (
                <Button
                  type="primary"
                  style={{ minWidth: 150, fontWeight: 'bold' }}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  shape="round"
                  disabled={
                    form
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  Enviar
                </Button>
              )}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Col>
  )
}

export default SendMessageForm;